module.exports = __webpack_public_path__ + "media/images/icons/brush-89f7cbeeda41dbd3c03cc2867f6fc651.svg";